/* OTODOR side cart: apply code, one-tap add-ons, and a shared helper that
   re-renders + opens Dawn's cart drawer after any AJAX add. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function drawer() { return document.querySelector('cart-drawer'); }
  function refresh(open) {
    var d = drawer();
    if (!d) { window.location.href = root + 'cart'; return Promise.resolve(); }
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        d.renderContents({ sections: sections });
        if (!open) return;
        d.classList.remove('is-empty');
      });
  }
  window.otodorCartRefresh = refresh;
  window.otodorCartAdd = function (id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () { return refresh(true); });
  };
  document.addEventListener('click', function (e) {
    var apply = e.target.closest && e.target.closest('[data-otodor-apply]');
    if (apply) {
      e.preventDefault();
      apply.setAttribute('aria-busy', 'true');
      fetch(root + 'discount/' + encodeURIComponent(apply.getAttribute('data-otodor-apply')), { credentials: 'same-origin' })
        .then(function () { return refresh(true); })
        .catch(function () { apply.removeAttribute('aria-busy'); });
      return;
    }
    var add = e.target.closest && e.target.closest('[data-otodor-upsell]');
    if (add) {
      e.preventDefault();
      add.setAttribute('aria-busy', 'true');
      window.otodorCartAdd(add.getAttribute('data-otodor-upsell'), 1)
        .catch(function () { add.removeAttribute('aria-busy'); window.location.href = root + 'cart'; });
    }
  });
})();
